module.exports = __webpack_public_path__ + "static/img/placeholder.d38af25c.jpg";